import React from "react";
import { CSpinner } from "@coreui/react";

const Loading = (
  <CSpinner/>
);

export default Loading;
